// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pendente[data-v-39a91907]{color:#1f2d3d;background-color:#ffc107;font-weight:700}.ativa[data-v-39a91907]{background-color:#007bff}.ativa[data-v-39a91907],.cancelada[data-v-39a91907]{color:#fff;font-weight:700}.cancelada[data-v-39a91907]{background-color:#dc3545}.suspensa[data-v-39a91907]{color:#1f2d3d;background-color:silver;font-weight:700}.quitada[data-v-39a91907]{color:#fff;background-color:#28a745;font-weight:700}", ""]);
// Exports
module.exports = exports;
